import React, { useState } from "react";
import QRCardApplication from "../components/QrcodeCard/QRCardApplication";
import { getFileHash } from "../utils/utils";
import swal from "sweetalert";
import axios from "axios";
import { Modalprogress } from "../components/Modal/Modalprogress";
import { Modalsuccessfile } from "../components/Modal/Modalsuccessfile";
import AutoFillProgress from "../components/ProgressAnimation/AutoFillProgress";
const { REACT_APP_CORD_MIDDLEWARE, REACT_APP_VERIFY_TOKEN } = process.env;

export const ApplicationQr = () => {
  const [formData, setFormData] = useState({
    name: "",
    certificate_id: "",
    certificate_name: "",
    email: "",
    location: "",
  });

  const [successModal, setSuccessModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [blockHash, setBlockHash] = useState("");
  const [currentHash, setCurrentHash] = useState("");
  const [verified, setVerified] = useState();
  const [disabledFields, setDisabledFields] = useState({});
  
  // Auto-fill progress animation states
  const [showAutoFillProgress, setShowAutoFillProgress] = useState(false);
  const [autoFillPercentage, setAutoFillPercentage] = useState(0);
  const [filledFieldsCount, setFilledFieldsCount] = useState(0);
  const [totalFieldsCount, setTotalFieldsCount] = useState(0);

  // Handle file input change
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    const currentHash = await getFileHash(file);
    setCurrentHash(currentHash);
    setLoading(true);
    setTimeout(() => {
      verifyFile(currentHash);
    }, [6000]);

    setFormData((prev) => ({ ...prev, file }));
  };

  const verifyFile = async (hash) => {
    const response = await axios.post(
      `${REACT_APP_CORD_MIDDLEWARE}/verify/document/verify`,
      { filehash: hash },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${REACT_APP_VERIFY_TOKEN}`,
        },
        validateStatus: (status) => status < 500,
      }
    );

    if (response.status === 200) {
      setLoading(false);
      if (response.data?.data?.revoke) {
        swal({
          title: "Revoked",
          text: "Document is Revoked",
          icon: "error",
        });
      } else {
        setBlockHash(response.data?.data?.blockHash);
        setVerified(true);
        setSuccessModal(true);
      }
    } else if (response.status === 400) {
      setLoading(false);
      setVerified("error");
      swal({
        title: "Not anchored on chain",
        text: response.data.err || "An error occurred",
        icon: "error",
      });
    } else {
      setLoading(false);
      setVerified(false);
      swal({
        title: "Unable to process the request",
        text: response.data.error || "An unknown error occurred",
        icon: "error",
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();

    const outputData = {
      ...formData,
      file: formData.file ? formData.file.name : null, // or send as base64 if needed
    };
    alert("Form submitted! ");
  };
const jsonData = (data) => {

  let jsondata;
  try {
    jsondata = typeof data === "string" ? JSON.parse(data) : data;
  } catch (e) {
    console.error("Invalid JSON:", e);
    return;
  }

  const credential =
    jsondata.presentation?.VerifiableCredential?.[0]?.credentialSubject || {};

  const { "@context": context, ...rest } = credential;
  const keysToExtract = Object.keys(formData);

  const filteredData = Object.fromEntries(
    keysToExtract.map((key) => [key, rest[key] || ""])
  );

  // Calculate auto-fill progress
  const totalFields = keysToExtract.length;
  const filledFields = keysToExtract.filter(
    (key) => rest[key] && rest[key].toString().trim() !== ""
  ).length;
  const percentage =
    totalFields > 0 ? Math.round((filledFields / totalFields) * 100) : 0;

  // Set progress data
  setTotalFieldsCount(totalFields);
  setFilledFieldsCount(filledFields);
  setAutoFillPercentage(percentage);

  // Show animation if fields were filled
  if (filledFields > 0) {
    setShowAutoFillProgress(true);
  }

  setFormData(filteredData);

  const disabledMap = Object.fromEntries(
    keysToExtract.map((key) => [key, !!rest[key]])
  );

  setDisabledFields(disabledMap);
};


  // Handle auto-fill animation completion
  const handleAutoFillComplete = () => {
    setTimeout(() => {
      setShowAutoFillProgress(false);
    }, 1500); // Hide after a short delay
  };

  return (
    <div>
      <Modalprogress
        loading={loading}
        msg={[
          "Looking for digest on the chain...",
          `Verifying document on chain...<br/><span class="hash-text">File Hash: ${currentHash}</span>`,
        ]}
      />
      <Modalsuccessfile
        loading={successModal}
        msg={"Verification Successful"}
        txtmsg={
          "Document successfully verified on  weavenet.cord.network chain."
        }
        Identifier={null}
        blockhash={blockHash}
        fileHash={currentHash} //  line to pass the file hash
        onClose={() => {
          setSuccessModal(false);
        }}
      />

      <QRCardApplication jsonData={jsonData} />
      
      {/* Auto-fill progress animation */}
      <AutoFillProgress
        isVisible={showAutoFillProgress}
        percentage={autoFillPercentage}
        totalFields={totalFieldsCount}
        filledFields={filledFieldsCount}
        onAnimationComplete={handleAutoFillComplete}
      />
      
      <div className="container d-flex justify-content-center align-items-center mt-5 mb-6">
        <div className="col-md-5">
          <h2 className="mb-4 text-center">Application Form</h2>
          <form onSubmit={handleSubmit}>
            {/* Name */}
            <div className="mb-3">
              <label htmlFor="name" className="form-label">
                Name
              </label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  disabled={disabledFields.name}
                />
                {disabledFields.name && (
                  <span className="input-group-text">✅</span>
                )}
              </div>
            </div>

            {/* cert_id */}
            <div className="mb-3">
              <label htmlFor="certificate_id" className="form-label">
                Certifciate ID
              </label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  id="certificate_id"
                  name="Certificate ID"
                  value={formData.certificate_id}
                  onChange={handleChange}
                  disabled={disabledFields.certificate_id}
                />
                {disabledFields.certificate_id && (
                  <span className="input-group-text">✅</span>
                )}
              </div>
            </div>

            {/* cert_name */}
            <div className="mb-3">
              <label htmlFor="certificate_name" className="form-label">
                Certificate Name
              </label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  id="certificate_name"
                  name="Certificate Name"
                  value={formData.certificate_name}
                  onChange={handleChange}
                  disabled={disabledFields.certificate_name}
                />
                {disabledFields.certificate_name && (
                  <span className="input-group-text">✅</span>
                )}
              </div>
            </div>

            {/* Mail ID */}
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <div className="input-group">
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  disabled={disabledFields.email}
                />
                {disabledFields.email && (
                  <span className="input-group-text">✅</span>
                )}
              </div>
            </div>
            <div className="mb-3">
              <label htmlFor="location" className="form-label">
                Location
              </label>
              <input
                type="email"
                className="form-control"
                id="location"
                name="location"
                value={formData.location}
                onChange={handleChange}
                disabled={disabledFields.location}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="file" className="form-label">
                Upload Certificate
              </label>
              <div className="position-relative">
                <input
                  className={`form-control pe-5 ${
                    verified === true
                      ? "border-success"
                      : verified === "error"
                      ? "border-danger"
                      : ""
                  }`}
                  type="file"
                  id="file"
                  name="file"
                  onChange={handleFileChange}
                />
                {verified && (
                  <span
                    className={`position-absolute top-50 end-0 translate-middle-y me-3 fs-5 ${
                      verified === true ? "text-success" : "text-danger"
                    }`}
                    style={{ pointerEvents: "none" }}
                  >
                    {verified === true ? "✅" : "❌"}
                  </span>
                )}
              </div>
            </div>
            <button type="submit" className="btn btn-primary w-100 mb-5">
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
